<template>
  <div>
    <div class="icon-link" @click="onClick">
      <img src="@/assets/clock.svg" alt="時刻選択" />
    </div>
    <div v-show="isDialogOpen" class="background" @click="onClose"></div>
    <div v-show="isDialogOpen" class="dialog">
      <ul class="list">
        <li
          v-for="(item, index) in timeRouteList"
          :key="item.text"
          @click="onClickStartTime(item, index)"
          class="list-item"
        >
          <span v-if="index === 0">今すぐ出発</span>
          <span v-else>{{ index }}時間後に出発</span>
          <span class="time"
            >{{ formatDate(item.time) }} -
            {{ getEndtime(item.time, item.duration) }}</span
          >
          <span class="duration"
            ><img src="@/assets/clock.svg" class="clock" alt="" />{{
              formatDateFromSeconds(item.duration)
            }}</span
          >
          <img class="chev" src="@/assets/chevron.svg" />
        </li>
        <div v-if="predictionStatus !== 0" class="caution">
          <p class="center">事故が発生しています。</p>
          <p>
            事故の影響により、現在や今後の交通状況が、所要時間の予測で想定している交通状況と大きく異なっており、予測結果が実際とズレている可能性があります。詳細は下記URLからご確認ください。
          </p>
          <a
            href="https://predict.traveltime.jp/chuo-herashitai-kobotoke/"
            target="_blank"
            >https://predict.traveltime.jp/chuo-herashitai-kobotoke/</a
          >
        </div>
        <div class="button close" @click="onClose">閉じる</div>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import Firebase from "./../../firebase";

export default {
  name: "start-time-select-dialog",
  components: {},
  props: {
    timeRouteList: { type: Array, required: true },
    current: { type: String, required: true },
    predictionStatus: { type: Number, required: true },
  },
  data() {
    return {
      isDialogOpen: true,
    };
  },
  computed: {
    ...mapState([
      "search",
      "currentLat",
      "currentLng",
      "DepLatLng",
      "DesLatLng",
    ]),
    currentSearch() {
      if (this.current === "RouteSearch") {
        return this.search.dropspot;
      } else if (this.current === "JyutaiSearch") {
        return this.search.jyutai;
      }
    },
    currentDepLatLng() {
      if (this.current === "RouteSearch") {
        return this.DepLatLng.dropspot;
      } else if (this.current === "MyPage") {
        return this.DepLatLng.mypage;
      } else if (this.current === "JyutaiSearch") {
        return this.DepLatLng.jyutai;
      }
    },
    currentDesLatLng() {
      if (this.current === "RouteSearch") {
        return this.DesLatLng.dropspot;
      } else if (this.current === "MyPage") {
        return this.DesLatLng.mypage;
      } else if (this.current === "JyutaiSearch") {
        return this.DesLatLng.jyutai;
      }
    },
  },
  methods: {
    ...mapMutations(["setSearch", "setSearchState"]),
    zeroPaddingAndStr(num) {
      if (num < 10) {
        return "0" + String(num);
      }
      return String(num);
    },
    formatDate(date) {
      const hour = this.zeroPaddingAndStr(date.getHours());
      const minute = this.zeroPaddingAndStr(date.getMinutes());
      return `${hour}:${minute}`;
    },
    getEndtime(date, value) {
      const endtime = new Date(date.getTime() + value * 1000);
      const hour = this.zeroPaddingAndStr(endtime.getHours());
      const minute = this.zeroPaddingAndStr(endtime.getMinutes());
      return `${hour}:${minute}`;
    },
    onClick() {
      this.isDialogOpen = true;
    },
    onClose() {
      this.isDialogOpen = false;
    },
    formatDateFromSeconds(value) {
      // 秒からX時間Y分に変換
      const hour = Math.floor(value / 3600);
      const minute = Math.round((value % 3600) / 60);
      return `${hour}時間${minute}分`;
    },
    async onClickStartTime(item, index) {
      const param = {
        ...this.currentSearch,
        departureTime: item.time,
        route: item.route,
        timeIndex: index,
      };
      this.setSearch(param);
      if (index == 0) {
        this.setSearchState("result");
      }
      else {
        this.setSearchState("select");
      }
      if (index === 0) {
        const actionParams = {
          start_name: this.currentSearch.departure,
          start_lon: this.currentDepLatLng.lng(),
          start_lat: this.currentDepLatLng.lat(),
          start_time: item.time,
          goal_name: this.currentSearch.destination,
          goal_lat: this.currentDesLatLng.lng(),
          goal_lon: this.currentDesLatLng.lat(),
          goal_time: this.getEndtime(item.time, item.duration),
        };
        await Firebase.putLog({
          ActionType: "DepartDirectly",
          ActionParams: actionParams,
        });
      } else {
        const actionParams = {
          delay_time: index,
          start_name: this.currentSearch.departure,
          start_lon: this.currentDepLatLng.lng(),
          start_lat: this.currentDepLatLng.lat(),
          start_time: item.time,
          goal_name: this.currentSearch.destination,
          goal_lat: this.currentDesLatLng.lng(),
          goal_lon: this.currentDesLatLng.lat(),
          goal_time: this.getEndtime(item.time, item.duration),
        };

        await Firebase.putLog({
          ActionType: "DepartLater",
          ActionParams: actionParams,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../../unified.scss";
.icon-link {
  text-align: center;
  border-radius: 4px;
  padding-top: 2px 0;
  width: 32px;
  height: 32px;
  position: absolute;
  right: 0.25rem;
  bottom: 6rem;
  background: white;
  img {
    height: 30px;
    width: 30px;
  }
}
.background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}
.dialog {
  position: fixed;
  flex-direction: column;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-55%);
  background-color: white;
  z-index: 1001;
  width: calc(100% - 2rem * 2);
  overflow-y: scroll;
  padding: 0.75rem 1rem;
  border-radius: 12px;

  .list {
    list-style: none;
    padding: 0;
    margin: 0;
    font-size: 0.8rem;
    .list-item {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr 0.1fr;
      padding: 1rem 0.5rem;
      border-bottom: 1px solid #e7e7e7;
      align-items: center;
      .time {
        vertical-align: center;
        font-size: 0.8rem;
        color: #aaa;
      }
      .duration {
        display: flex;
        align-items: center;
      }
      .clock {
        height: 1rem;
        margin-right: 0.25rem;
      }
      .chev {
        height: 0.5rem;
        transform: rotate(-90deg);
      }
    }
  }
}
.caution {
  margin-top: 1rem;
  color: #ff7c86;
  font-size: 0.8rem;
  p {
    margin: 0.25rem 0;
  }
  .center {
    text-align: center;
  }
}
.button {
  color: #5cd5d6;
  margin-top: 2rem;
  padding: 0 0.75rem;
  text-align: center;
  font-size: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/JyutaiSearch/StartTimeSelectDialog.vue